var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ai-dialog-content"},[_vm._t("content")],2),_c('v-divider',{staticClass:"ai-dialog-divider"}),_c('div',{staticClass:"ai-dialog-footer"},[_vm._t("footer")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }